import type ModuleButtonsType from '../components/ModuleButtonsType';
import { showAddToCampaignDialog, showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showAddNotesDialog } from 'app/main/submodules/notes/NotesAddDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';
import { showFastAddDialog } from '../components/FastAddDialog';

const buttons: ModuleButtonsType = {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'people'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(showFastAddDialog({ module: 'people', updateRefresh, isUpdate: true, model }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_NOTE',
				icon: 'comment-text-multiple-outline',
				iconAdd: true,
				action: ({ model, dispatch }) =>
					dispatch(showAddNotesDialog({ model: { note_table: 'people', note_table_uid: model.peop_uid } }))
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_comp_uid: model.peop_comp_uid,
								chro_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_comp_uid: model.peop_comp_uid,
								oppo_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_comp_uid: model.peop_comp_uid,
								cntr_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
				icon: 'basket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'orders',
							updateRefresh,
							model: {
								ords_comp_uid: model.peop_comp_uid,
								ords_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_comp_uid: model.peop_comp_uid,
								proj_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_comp_uid: model.peop_comp_uid,
								acti_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: {
								tick_comp_uid: model.peop_comp_uid,
								tick_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'people'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showDeleteDialog({
							module: 'people',
							id: model.peop_uid,
							title: model.peop_title,
							updateRefresh
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				hidden: ({ authorizer }) => authorizer.cannot('create', 'people'),
				action: () => Utils.openLink({ pathname: '/people/add' })
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				hidden: ({ authorizer }) => authorizer.cannot('export', 'people'),
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				hidden: ({ authorizer }) => authorizer.cannot('view', 'logs'),
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'people'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'people',
							id: model.peop_uid,
							title: model.peop_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'people'),
				action: ({ switchEdit }) => switchEdit()
			},
			{
				id: 'chronology',
				name: 'VIEW_ITEM_BUTTON_NEW_EVENT',
				icon: 'history',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('chronology') || authorizer.cannot('create', 'chronology'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'chronology',
							updateRefresh,
							model: {
								chro_comp_uid: model.peop_comp_uid,
								chro_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				id: 'commercialcampaigns',
				name: 'DETAILS_HEADER_BUTTON_ADD_TO_COMMERCIALCAMPAIGN',
				icon: 'binoculars',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('commercialcampaigns') || authorizer.cannot('update', 'commercialcampaigns'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showAddToCampaignDialog({
							model,
							updateRefresh,
							module: 'commercialcampaigns',
							table: 'people'
						})
					)
			},
			{
				id: 'marketingactions',
				name: 'DETAILS_HEADER_BUTTON_ADD_TO_MARKETINGACTION',
				icon: 'bullhorn',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('marketingactions') || authorizer.cannot('update', 'marketingactions'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(
						showAddToCampaignDialog({
							model,
							updateRefresh,
							module: 'marketingactions',
							table: 'people'
						})
					)
			},
			{
				id: 'dems',
				name: 'DETAILS_HEADER_BUTTON_ADD_TO_DEM',
				icon: 'email-multiple-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('dems') || authorizer.cannot('update', 'dems'),
				action: ({ model, dispatch, updateRefresh }) =>
					dispatch(showAddToCampaignDialog({ model, updateRefresh, module: 'dems', table: 'people' }))
			},
			{
				id: 'opportunities',
				name: 'VIEW_ITEM_BUTTON_NEW_OPPORTUNITY',
				icon: 'thought-bubble-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('opportunities') || authorizer.cannot('create', 'opportunities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'opportunities',
							updateRefresh,
							model: {
								oppo_comp_uid: model.peop_comp_uid,
								oppo_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				id: 'contracts',
				name: 'VIEW_ITEM_BUTTON_NEW_CONTRACT',
				icon: 'file-document-edit-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('contracts') || authorizer.cannot('create', 'contracts'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'contracts',
							updateRefresh,
							model: {
								cntr_comp_uid: model.peop_comp_uid,
								cntr_peop_uid: model.peop_uid
							}
						})
					)
			},
			// {
			// 	id: 'orders',
			// 	name: 'VIEW_ITEM_BUTTON_NEW_ORDER',
			// 	icon: 'basket',
			// 	iconAdd: true,
			// 	hidden: ({ isModuleDisabled, authorizer }) =>
			// 		isModuleDisabled('orders') || authorizer.cannot('create', 'orders'),
			// 	action: ({ dispatch, updateRefresh, model }) =>
			// 		dispatch(
			// 			showFastAddDialog({
			// 				module: 'orders',
			// 				updateRefresh,
			// 				model: {
			// 					ords_comp_uid: model.peop_comp_uid,
			// 					ords_peop_uid: model.peop_uid
			// 				}
			// 			})
			// 		)
			// },
			{
				id: 'projects',
				name: 'VIEW_ITEM_BUTTON_NEW_PROJECT',
				icon: 'clipboard-text-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('projects') || authorizer.cannot('create', 'projects'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'projects',
							updateRefresh,
							model: {
								proj_comp_uid: model.peop_comp_uid,
								proj_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				id: 'activities',
				name: 'VIEW_ITEM_BUTTON_NEW_ACTIVITY',
				icon: 'puzzle-outline',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('activities') || authorizer.cannot('create', 'activities'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'activities',
							updateRefresh,
							model: {
								acti_comp_uid: model.peop_comp_uid,
								acti_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				id: 'tickets',
				name: 'VIEW_ITEM_BUTTON_NEW_TICKET',
				icon: 'ticket',
				iconAdd: true,
				hidden: ({ isModuleDisabled, authorizer }) =>
					isModuleDisabled('tickets') || authorizer.cannot('create', 'tickets'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'tickets',
							updateRefresh,
							model: {
								tick_comp_uid: model.peop_comp_uid,
								tick_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				id: 'lead-companies',
				name: 'DETAILS_HEADER_BUTTON_NEW_LEAD_COMPANY',
				icon: 'domain',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'companies'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'companies',
							updateRefresh,
							model: {
								comp_broker_peop_uid: model.peop_uid
							}
						})
					)
			},
			{
				id: 'lead-people',
				name: 'DETAILS_HEADER_BUTTON_NEW_LEAD_PERSON',
				icon: 'card-account-details-outline',
				iconAdd: true,
				hidden: ({ authorizer }) => authorizer.cannot('create', 'people'),
				action: ({ dispatch, updateRefresh, model }) =>
					dispatch(
						showFastAddDialog({
							module: 'people',
							updateRefresh,
							model: {
								peop_broker_peop_uid: model.peop_uid
							}
						})
					)
			}
		]
	}
};

export default buttons;
